import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rich-text-placeholders"
export default class extends Controller {
  static targets = ["content"]

  insert(event) {
    const placeholder = event.currentTarget.dataset.placeholder
    if (!placeholder || !this.editorInstance) return

    this.editorInstance.insertString(`[[${placeholder}]]`)
    this.contentTarget.focus()
  }

  get editorInstance() {
    return this.contentTarget?.editor
  }
}
